import React, { Fragment, useContext } from "react";
import propTypes from "prop-types";
import { Booking } from "../../../../logic/api";
import styles from "./styles";

import {
    FiAlertTriangle,
} from 'react-icons/fi';

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";
import { SessionContext } from "../../../../utility/useSession";
import { IconType } from "react-icons/lib";
import { formatVehicle } from "../../../../utility/utils";
import { useTranslation } from "react-i18next";
import { getVehicleStatusKey } from "../../../../i18n/helpers";
import flex from "../../../../styles/flex";


const AuditListItem: React.FunctionComponent<{
    row?: number | null;
    booking: Booking;
    warning?: string;
    icon?: IconType | null;
    isMarkedAsMissing?: boolean;
    onClick?: () => void
}> = (props) => {

    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const border = styles.bookingListItemBorder(props.booking.vehicle.statusId);

    const statusKey = getVehicleStatusKey(props.booking.vehicle.statusId);
    const translatedStatus = t(statusKey)

    const hasRow = props.row != null && props.row != 0;

    if (session.current.site == null) {
        return <Fragment />
    }

    return <div style={{
        ...styles.bookingListItem, ...border, paddingBottom: props.warning != null ? 0 : 20,
        backgroundColor: props.isMarkedAsMissing ? "#DDD" : "#FFF",
        opacity: props.isMarkedAsMissing ? 0.5 : 1
    }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>

        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{translatedStatus}</span>
        </div>
        <div style={styles.bookingListItemFlex}>
            <ListViewItemCard
                icon={
                    <Fragment>
                        {hasRow == true && (
                            <div style={{ ...flex.flexRows }}>
                                <div style={flex.flexFill}>
                                    <div style={{
                                        textAlign: "center",
                                        width: 26,
                                        height: 24,
                                        borderRadius: 28,
                                        fontSize: 15,
                                        paddingTop: 2,
                                        marginRight: props.icon == null ? 10 : 0,
                                        backgroundColor: "#EEE",
                                        color: "#000",
                                        fontWeight: "bold",
                                        border: "solid 2px #DDD",
                                        display: "inline-block",
                                        verticalAlign: "middle",
                                    }}>
                                        {props.row}
                                    </div>
                                </div>
                                {
                                    (props.row != null && props.icon != null && (
                                        <div style={flex.flexFill}>
                                            <props.icon style={styles.icon} />
                                        </div>
                                    ))

                                }
                            </div>
                        )}
                        {hasRow == false && props.icon != null && (
                            <props.icon style={styles.icon} />
                        )}
                    </Fragment>
                }

                text={props.booking.vehicle.registration}
                subText={formatVehicle(props.booking.vehicle)}

            />


        </div>

        {props.warning != null && (
            <div style={{ color: "red", textAlign: "right", padding: 5 }}>
                <FiAlertTriangle /> <strong>{props.warning}</strong>
            </div>
        )}
    </div>
}


AuditListItem.propTypes = {
    row: propTypes.any,
    booking: propTypes.any.isRequired,
    icon: propTypes.any,
    onClick: propTypes.func,
    warning: propTypes.string,
    isMarkedAsMissing: propTypes.bool
};


export default AuditListItem;
